import * as tr46 from 'tr46'

export class Punycode {
  static safeDecode(input: string): string {
    try {
      const decoded = tr46.toUnicode(input)
      if (decoded.error) {
        return input
      }
      return decoded.domain
    } catch (e) {
      return input
    }
  }
}
